import { createFileRoute } from '@tanstack/react-router';

import { ExpensesPage } from '@/features/expenses/expenses.page';

export const Route = createFileRoute('/__authenticated/expenses/')({
	component: ExpensesPage,
});
